export const RouterConfig = {
  root: "/",
  pipelines: "/pipelines",
  instruments: "/instruments",
  noteTypes: "/note-types",
  tosVersions: "/tos-versions",
  sections: "/sections",
  families: "/families",
  hooks: "/hooks",
  roles: "/roles",
  actions: "/actions",
  events: "/events",
  payrollForms: "/payrollForms",
  forms: "/forms",
  configurations: "/configurations",
};
